module.exports = __webpack_public_path__ + "img/icono-15-2.17ae265a.png";